export default __webpack_public_path__ + "static/media/cizma14.9d2a5807.jpg";